
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddHeader from '../components/AddHeader/AddHeader';
import FormContainer from '../components/FormContainer/FormContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchProducts, updateProduct } from '../hooks/Products';
import { fetchCategories } from '../hooks/categories';

function EditProduct() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: products } = useSelector((state) => state.products);
  const { list: categories } = useSelector((state) => state.categories);
  const productsData = products?.find((item) => item?.id == id)
  const categoriesOptions = categories.map((item) => ({
    value: item?.id, label: currentLocal.language === "العربيه" ? item?.name_ar : item?.name_en
  }))
  const [ar_productName, setar_productName] = useState('')
  const [en_productName, seten_productName] = useState('')
  const [price, setPrice] = useState('')
  const [catID, setcatID] = useState('')
  const [description_ar, setdescription_ar] = useState('')
  const [description_en, setdescription_en] = useState('')
  const [priceAfterDiscount, setpriceAfterDiscount] = useState('')
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [loading, setLoading] = useState(false)
  const [attributes, setAttributes] = useState([
    { attribute_id: "", attribute_value_id: "" }
  ]);
const [variants, setVariants] = useState([
 { size_title:"", color_title:"", quantity:"" }
]);
  const [sizes, setSizes] = useState([{ id: "", title: "", quantity: "" }]);
  const [colors, setColors] = useState([{ id: "", title: "", quantity: "" }]);

  // وظائف التحكم في المقاسات
  const handleSizeChange = (index, field, value) => {
    const newSizes = [...sizes];
    newSizes[index][field] = value;
    setSizes(newSizes);
  };
  const addSizeRow = () => setSizes([...sizes, { id: "", title: "", quantity: "" }]);
  const removeSizeRow = (index) => setSizes(sizes.filter((_, i) => i !== index));

  // وظائف التحكم في الألوان
  const handleColorChange = (index, field, value) => {
    const newColors = [...colors];
    newColors[index][field] = value;
    setColors(newColors);
  };
  const addColorRow = () => setColors([...colors, { id: "", title: "", quantity: "" }]);
  const removeColorRow = (index) => setColors(colors.filter((_, i) => i !== index));









const handleVariantChange = (index, field, value) => {
 const newVariants = [...variants];
 newVariants[index][field] = value;
 setVariants(newVariants);
};

const addVariantRow = () => {
 setVariants([...variants,{ size_title:"", color_title:"", quantity:"" }]);
};

const removeVariantRow = (index) => {
 setVariants(variants.filter((_,i)=> i !== index));
};


  useEffect(() => {
    if (productsData) {
      setar_productName(productsData?.name_ar || '');
      seten_productName(productsData?.name_en || '');
      setcatID({
        label: currentLocal.language === "العربيه" ? productsData?.category?.name_ar : productsData?.category?.name_en,
        value: productsData?.category?.id
      });
      setImagePreviews(productsData?.images || []);
      setPrice(productsData?.price_egp || '');
      setpriceAfterDiscount(productsData?.discounted_price_egp || '');
      setdescription_ar(productsData?.description_ar || '');
      setdescription_en(productsData?.description_en || '');

      if (productsData?.variants?.length > 0) {
        setVariants(
          productsData.variants.map(v => ({
            id: v.id,
            size_title: v?.size?.title,
            color_title: v?.color?.title,
            quantity: v.quantity
          }))
        )
      }
    }
  }, [productsData, currentLocal.language]);

  const handleAttributeChange = (index, field, value) => {
    const newAttributes = [...attributes];
    newAttributes[index][field] = value;
    setAttributes(newAttributes);
  };

  const addAttributeRow = () => {
    setAttributes([...attributes, { attribute_id: "", attribute_value_id: "", price_egp: "", price_sar: "" }]);
  };

  const removeAttributeRow = (index) => {
    setAttributes(attributes.filter((_, i) => i !== index));
  };
  useEffect(() => {
    dispatch(fetchCategories());

  }, [dispatch])


  const handleImageChange = (e) => {
    const files = e.target.files;
    if (!files.length) return;

    setImages(prevImages => [...prevImages, ...Array.from(files)]);
    setImagePreviews(prevPreviews => [
      ...prevPreviews,
      ...Array.from(files).map(file => URL.createObjectURL(file))
    ]);
  };


  //   useEffect(() => {

  // console.log(productsData);

  //     setar_productName(productsData?.name_ar)
  //     seten_productName(productsData?.name_en)
  //     setcatID({label:currentLocal.language === "العربيه" ?productsData?.category?.name_ar:productsData?.category?.name_en,value:productsData?.category?.id})
  //     setImagePreviews(productsData?.images)
  //     setPrice(productsData?.price_egp)
  //     setpriceAfterDiscount(productsData?.discounted_price_egp)
  // setdescription_ar(productsData?.description_ar)
  // setdescription_en(productsData?.description_en)


  //   }, [])
  const addAttribute = (
    <div className="attributes-section">
      <h6 className="mb-3 mt-4 border-bottom pb-2 text-primary">
        {currentLocal.language=="English"?"Variants":"المتغيرات"}
      </h6>


{variants.map((item,index)=>(
<div key={index} className="row mb-2 align-items-end">

<div className="col-md-4">
<label>Size</label>
<input
className="form-control"
value={item.size_title}
onChange={(e)=>handleVariantChange(index,"size_title",e.target.value)}
/>
</div>

<div className="col-md-4">
<label>Color</label>
<input
className="form-control"
value={item.color_title}
onChange={(e)=>handleVariantChange(index,"color_title",e.target.value)}
/>
</div>

<div className="col-md-3">
<label>Quantity</label>
<input
type="number"
className="form-control"
value={item.quantity}
onChange={(e)=>handleVariantChange(index,"quantity",e.target.value)}
/>
</div>

<div className="col-md-1">
<button
type="button"
className="btn btn-danger"
onClick={()=>removeVariantRow(index)}
>
X
</button>
</div>

</div>
))}

<button
type="button"
className="btn btn-sm btn-outline-secondary"
onClick={addVariantRow}
>
+ Add Variant
</button>
    </div>
  );
  const inputs = [
    { id: 0, name: currentLocal.home.namePlaceholder + " " + currentLocal.home.inEN, value: en_productName, onChanegFunction: (e) => seten_productName(e.target.value), grid: 6 },
    // { id: 1, name: currentLocal.home.namePlaceholder + " " + currentLocal.home.inAR, value: ar_productName, onChanegFunction: (e) => setar_productName(e.target.value), grid: 6 },
    { id: 2, name: currentLocal.home.ProductCategory, value: catID, grid: 6, onChanegFunction: (selectedlecturer) => setcatID(selectedlecturer), type: "select", options: categoriesOptions },
    { id: 3, name: currentLocal.home.price, value: price, onChanegFunction: (e) => setPrice(e.target.value), grid: 6 },
    { id: 4, name: currentLocal.home.priceAfterDiscount, value: priceAfterDiscount, onChanegFunction: (e) => setpriceAfterDiscount(e.target.value), grid: 6 },
    { id: 5, name: currentLocal.home.description_en, value: description_en, onChanegFunction: (e) => setdescription_en(e.target.value), grid: 6 },
    // { id: 6, name: currentLocal.home.description_ar, value: description_ar, onChanegFunction: (e) => setdescription_ar(e.target.value), grid: 6 },
    { id: 7, name: currentLocal.home.images, onChanegFunction: handleImageChange, grid: 6, type: "file", multiple: true, accept: "image/*" },

  ]

  const handleSubmit = () => {
    const formData = new FormData();

    formData.append("category_id", catID?.value)
    formData.append("code", "PROD-0012340562")
    formData.append("description_ar", description_ar)
    formData.append("description_en", description_en)
    formData.append("price_egp", price)
    formData.append("price_sar", price)
    formData.append("discounted_price_egp", priceAfterDiscount)
    formData.append("name_ar", ar_productName)
    formData.append("name_en", en_productName)


variants.forEach((item,index)=>{

 if(item.id){
  formData.append(`variants[${index}][id]`,item.id)
 }

 formData.append(`variants[${index}][size_title]`,item.size_title)
 formData.append(`variants[${index}][color_title]`,item.color_title)
 formData.append(`variants[${index}][quantity]`,item.quantity)

})



    // attributes.forEach((attr, index) => {
    //     formData.append(`attributes[${index}][attribute_id]`, attr.attribute_id);
    //     formData.append(`attributes[${index}][attribute_value_id]`, attr.attribute_value_id);
    //     formData.append(`attributes[${index}][price_egp]`, 0);
    //     formData.append(`attributes[${index}][price_sar]`, 0);
    // });
    images.forEach((image, index) => {
      formData.append(`images[${index}]`, image); // Append each image with a unique key
    });

    setLoading(true)

    dispatch(updateProduct({ id, data: formData }))
      .unwrap()
      .then(() => {
        setLoading(false)
        dispatch(fetchProducts())
        alert(currentLocal.home.edidedsuccessfully)
        navigate("/dashboard/products")

      })
      .catch((err) => {
        setLoading(false)

      });
  }
  return (
    <div className='outlit_bg'>
      <AddHeader
        title={currentLocal.home.editproduct}
      />
      <div className='body_container mx-4'  >
        <p className='border-bottom pb-3'>{currentLocal.home.editproduct}</p>
        <FormContainer
          inputs={inputs}
          btnText={currentLocal.home.Save}
          handleSubmit={handleSubmit}
          loading={loading}
          imagePreview={imagePreviews}
          content={addAttribute}

        />
      </div>
    </div>
  )
}

export default EditProduct
